import { render, staticRenderFns } from "./LabelSendDetails.vue?vue&type=template&id=ee69c68c&scoped=true"
import script from "./LabelSendDetails.vue?vue&type=script&lang=js"
export * from "./LabelSendDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee69c68c",
  null
  
)

export default component.exports